import React from 'react';
import styles from './FeatureFirst.module.css'
import icon from '../../../images/Features/Mask group.webp'
import {motion} from 'framer-motion'

const FeatureFirst = ({openModal}) => {
    return (
        <div className={styles.feature_container}>
            <motion.div
                initial={{opacity: 0, x: 200}}
                whileInView={{opacity: 1, x: 0}}
                transition={{duration: 1}}
                viewport={{once: true}}
                className="p-6 bg-blue-500 text-white rounded-lg shadow-lg"
            >
                <h1 className={styles.header}>
                    Втомилися сидіти вдома і дивитися серіали? <span
                    className={styles.first_span}> У вас просто не було <span
                    style={{color: 'red'}}>Ігрової консолі</span>!</span>
                </h1>
                <div className={styles.row}>
                    <div className={styles.image_container}>
                        <img src={icon} alt=""/>
                    </div>
                    <span className={styles.second_span}>У вас просто не було <span
                        style={{color: 'red'}}>Ігрової консолі</span>!</span>
                    <div className={styles.column}>
                        <p>Оформи оренду зараз, а ввечері вже грай.</p>
                        <ul>
                            <li>Доставка в найкоротші терміни</li>
                            <li>Величезний вибір ігор для двох</li>
                            <li>Можна повернути в будь-який час або продовжити оренду</li>
                        </ul>
                        <div>
                            <button onClick={() => openModal()}>Отримати консоль</button>
                        </div>
                    </div>
                </div>
                </motion.div>
        </div>
);
};

export default FeatureFirst;